import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Fragment } from 'react/cjs/react.production.min';
import { Footer } from '../../Component/Footer/Footer';
import { Header } from '../../Component/Header/Header';
import { fetchData } from '../../Utils/fetch';
import { Toptips } from '../Home/HomeStyle';
import { styleContextApp } from '../StyleContext';
import { ButtonWrapper, ConfirmContent, ConfirmItemWrapper, ConfirmTitle, ConfirmWrapper, LeftButton, RightButton } from './ConfirmStyle';
import closeWhite from '../Reserve/closeWhite.png';

export const Confirm = (props) => {
    const location = useLocation();
    const styleType = useContext(styleContextApp);
    const navigate  = useNavigate(); 
    const [ showTips, setShowTips ] = useState(false);
    const [ errorMessage, setErrorMessage ] = useState('');


    useEffect(() => {
        window.scrollTo(0,0);
    }, [])

    if(!location.state) {
        return null;
    }
    const {plan, reserveDate, roomNumber, peopleNumber, tele, email, name, line, coverImgUrl, content, wechat, innId} = location.state;
    const confirmSending = async () => {
        try {
            const data = await fetchData(`reserve`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json'
              },
            body: JSON.stringify({
                "innId": content.innId,
                "innPlanId": plan.id,
                "checkinDate": reserveDate[0],
                "checkoutDate": reserveDate[1],
                "guests": {
                  "adult": peopleNumber[0],
                  "child": peopleNumber[1]
                },
                "rooms": 
                content.roomTypeList.reduce((previous, currentType, index) => {
                    return {...previous, [currentType]: roomNumber[index]};
                }, {}),
                "name": name,
                "phone": tele,
                "email": email,
                "lineId": line,
                "wechatId": wechat,
            })});
            navigate('/thanks', {state: {coverImgUrl}});
        } catch(e) {
                setShowTips(true);
                setErrorMessage((e && e.message) || '請檢查網絡連接後重試～。');
        }
    }
    const backToFix = () => {
        navigate(`/reserve/${innId}`, {state: {plan, reserveDate, roomNumber, peopleNumber, tele, email, name, coverImgUrl, content, line, wechat}})
    }
    return (
        <Fragment>
                       {
                showTips  && 
                <Toptips id='toptip' styleType={styleType} color={'#BA5B5B'}>
                    <span>{errorMessage}</span>
                    <img id='close' src={closeWhite} alt='' onClick={() => setShowTips(false)}></img>
                </Toptips>
            }
            <Header title={'確認您的預定信息'} styleType={styleType} pictures={[coverImgUrl]} hasMarginTop={false} headerHeight={584} mobileHeight={404}/>
            <ConfirmWrapper styleType={styleType}>
                <ConfirmItemWrapper styleType={styleType}>
                    <ConfirmTitle styleType={styleType}>
                        <span/>
                        旅舍名稱和套餐
                    </ConfirmTitle>
                    <ConfirmContent styleType={styleType}>
                        <b>旅舍名稱：</b>{content.name.substring(0, 20)} 
                        <p></p>
                        <b>套餐：</b> {plan.title.substring(0, 20)}
                    </ConfirmContent>
                </ConfirmItemWrapper>
                <ConfirmItemWrapper styleType={styleType}>
                    <ConfirmTitle styleType={styleType}>
                        <span/>
                         入住人數
                    </ConfirmTitle>
                    <ConfirmContent styleType={styleType}>
                        <b>大人:</b> {peopleNumber[0]} 
                        <p></p>
                        <b>小孩:</b> {peopleNumber[1]}
                    </ConfirmContent>
                </ConfirmItemWrapper>
                <ConfirmItemWrapper styleType={styleType}>
                    <ConfirmTitle styleType={styleType}>
                        <span/>
                        入住日期
                    </ConfirmTitle>
                    <ConfirmContent styleType={styleType}>
                        <b>{reserveDate[0]}</b> ～ <b>{reserveDate[1]}</b>
                    </ConfirmContent>
                </ConfirmItemWrapper>
                <ConfirmItemWrapper styleType={styleType}>
                    <ConfirmTitle styleType={styleType}>
                        <span/>
                        房間數和房間類型
                    </ConfirmTitle>
                    <ConfirmContent styleType={styleType}>
                        {(content.roomTypeList).map((e,index) => {
                            if(roomNumber[index] === 0) return null;
                            return (
                                <Fragment key={e}>
                                    <b>{e}</b> {roomNumber[index]} 
                                    <p></p>  
                                </Fragment>
                            );
                        })}
                    </ConfirmContent>
                </ConfirmItemWrapper>
                <ConfirmItemWrapper styleType={styleType}>
                    <ConfirmTitle styleType={styleType}>
                        <span/>
                        聯繫人姓名
                    </ConfirmTitle>
                    <ConfirmContent styleType={styleType}>
                        {name}
                    </ConfirmContent>
                </ConfirmItemWrapper>
                {
                    tele && (
                        <ConfirmItemWrapper styleType={styleType}>
                            <ConfirmTitle styleType={styleType}>
                                <span/>
                                聯繫人電話
                            </ConfirmTitle>
                            <ConfirmContent styleType={styleType}>
                            {tele}
                            </ConfirmContent>
                        </ConfirmItemWrapper>
                    )
                }
                {
                    email && (
                        <ConfirmItemWrapper styleType={styleType}>
                            <ConfirmTitle styleType={styleType}>
                                <span/>
                                聯繫人郵箱
                            </ConfirmTitle>
                            <ConfirmContent styleType={styleType}>
                                {email}
                            </ConfirmContent>
                        </ConfirmItemWrapper>
                    )
                }
                {
                    line && (
                        <ConfirmItemWrapper styleType={styleType}>
                            <ConfirmTitle styleType={styleType}>
                                <span/>
                                LINE
                            </ConfirmTitle>
                            <ConfirmContent styleType={styleType}>
                                {line}
                            </ConfirmContent>
                        </ConfirmItemWrapper>
                    )
                }
                {
                    wechat && (
                        <ConfirmItemWrapper styleType={styleType}>
                            <ConfirmTitle styleType={styleType}>
                                <span/>
                                微信號
                            </ConfirmTitle>
                            <ConfirmContent styleType={styleType}>
                                {wechat}
                            </ConfirmContent>
                        </ConfirmItemWrapper>
                    )
                }

                
            </ConfirmWrapper>
            <ButtonWrapper styleType={styleType}>
                <LeftButton styleType={styleType}><span onClick={backToFix}>返回修改</span></LeftButton>
                <RightButton styleType={styleType} onClick={confirmSending}>確認發送</RightButton>
            </ButtonWrapper>
            <Footer styleType={styleType}></Footer>

        </Fragment>
    );
}

